

<section class="bg-white dark:bg-gray-900">
    <div class="max-w-screen-xl px-1 py-8 mx-auto w-full lg:py-24 lg:px-6">
        <div class="max-w-screen-md mx-auto mb-8 text-center lg:mb-12">
            <h2 class="mb-4 text-2xl sm:text-3xl font-extrabold tracking-tight text-gray-900 dark:text-white">
                Choisissez l'offre qui correspond à votre usage</h2>
            <p class="mb-5 font-bold text-gray-500 sm:text-xl dark:text-gray-400">
                1 jeton = 5 €
            </p>
            <p class="mb-5 font-bold text-gray-500 sm:text-xl dark:text-gray-400">
                Profitez des prédictions proposées par Coteo sur vos sports préférés grâce à un système flexible
                d’abonnement ou d’achat d'analyses personalisées à
                l’unité.
            </p>
            <p class="mb-5 font-bold text-gray-500 sm:text-xl dark:text-gray-400">
                4 jetons = accès 30 jours Pack Starter ou 4 analyses personnalisées.
            </p>
        </div>

        <div class="space-y-8 lg:grid lg:grid-cols-3 sm:gap-6 xl:gap-10 lg:space-y-0 w-full">
            @for( plans of listOfPlans(); track plans) {
            <div
                class="flex flex-col max-w-full sm:max-w-lg p-4 sm:p-6 mx-auto text-center text-gray-900 bg-white border border-gray-100 rounded-lg shadow dark:border-gray-600 dark:bg-gray-800 dark:text-white">
                <h3 class="mb-4 text-xl sm:text-2xl font-semibold">{{plans.name}}</h3>
                <p class="font-light text-gray-500 sm:text-lg dark:text-gray-400">
                    {{plans.description}} </p>
                <div class="flex items-baseline justify-center my-6 sm:my-8">
                    <span class="mr-2 text-3xl sm:text-5xl font-extrabold">{{plans.price_credits}} </span>
                    <span class="font-bold">euros &nbsp;</span>
                    <span class=""> /&nbsp;mois</span>
                </div>

                <ul role="list" class="mb-6 sm:mb-8 space-y-2 sm:space-y-4 text-left">
                    @if(plans.id === '4') {
                    <li class="flex items-center space-x-3">
                        <svg class="flex-shrink-0 w-5 h-5 text-green-500 dark:text-green-400" fill="currentColor"
                            viewBox="0 0 20 20">
                            <path fill-rule="evenodd"
                                d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                                clip-rule="evenodd"></path>
                        </svg>
                        <span>Accès à l'outil Coteo-Scrap</span>
                    </li>
                    }
                    <li class="flex items-center space-x-3">
                        <svg class="flex-shrink-0 w-5 h-5 text-green-500 dark:text-green-400" fill="currentColor"
                            viewBox="0 0 20 20">
                            <path fill-rule="evenodd"
                                d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                                clip-rule="evenodd"></path>
                        </svg>
                        @if(plans.id === '1') {
                        <span>Accès illimité aux prédictions Football</span>
                        } @else if (plans.id === '2') {
                        <span>Accès illimité aux prédictions Tennis</span>
                        } @else if (plans.id === '3') {
                        <span>Accès illimité aux prédictions sur tous les sports</span>
                        } @else if (plans.id === '4') {
                        <span>Accès illimité aux prédictions sur tous les sports</span>
                        }
                    </li>


                    <li class="flex items-center space-x-3">
                        <svg class="flex-shrink-0 w-5 h-5 text-green-500 dark:text-green-400" fill="currentColor"
                            viewBox="0 0 20 20">
                            <path fill-rule="evenodd"
                                d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                                clip-rule="evenodd"></path>
                        </svg>
                        <span>30 jours d’accès</span>
                    </li>
                    <li class="flex items-center space-x-3">
                        <svg class="flex-shrink-0 w-5 h-5 text-green-500 dark:text-green-400" fill="currentColor"
                            viewBox="0 0 20 20">
                            <path fill-rule="evenodd"
                                d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                                clip-rule="evenodd"></path>
                        </svg>
                        <span>Mise à jour quotidienne</span>
                    </li>
                    <li class="flex items-center space-x-3">
                        <svg class="flex-shrink-0 w-5 h-5 text-green-500 dark:text-green-400" fill="currentColor"
                            viewBox="0 0 20 20">
                            <path fill-rule="evenodd"
                                d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                                clip-rule="evenodd"></path>
                        </svg>
                        <span>Assistance prioritaire</span>
                    </li>
                    <li class="flex items-center space-x-3">
                        <svg class="flex-shrink-0 w-5 h-5 text-green-500 dark:text-green-400" fill="currentColor"
                            viewBox="0 0 20 20">
                            <path fill-rule="evenodd"
                                d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                                clip-rule="evenodd"></path>
                        </svg>
                        <span>Sans engagement</span>
                    </li>
                </ul>
                <p-button [disabled]="loadingSubscriptionToPlan() === plans.id"
                    class="w-full text-white focus:ring-4 focus:ring-purple-200 font-medium rounded-lg text-base sm:text-sm text-center dark:text-white dark:focus:ring-purple-900"
                    (click)="subscribeToPlan(plans)">
                    Choisir
                </p-button>
            </div>
            }
        </div>
    </div>
</section>

<p-dialog header="Choix du pack" [modal]="true" [(visible)]="visible" [style]="{ width: '100%', maxWidth: '40rem' }">
    <p-table [value]="listOfPacks() || []" [tableStyle]="{ 'min-width': '100%' }">
        <ng-template #header>
            <tr>
                <th>Pack</th>
                <th>Prix (€)</th>
                <th>Jetons</th>
                <th></th>
            </tr>
        </ng-template>
        <ng-template #body let-pack>
            <tr>
                <td>{{ pack.name }}</td>
                <td>{{ pack.price }}</td>
                <td>{{ pack.credits }}</td>
                <td>
                    <p-button label="Acheter" severity="success" (click)="purchase_pack(pack)" class="w-full" />
                </td>
            </tr>
        </ng-template>
    </p-table>
</p-dialog>

<p-dialog [(visible)]="showConfirmDialog" [modal]="true" [draggable]="false" [resizable]="false"
    [style]="{ width: '400px' }" header="Confirmer l'achat">

    <div class="text-center">
        <h3 class="text-lg font-semibold mb-4">Confirmer votre demande</h3>
        <span>Êtes-vous sûr de vouloir souscrire au plan <span class="font-bold">{{ planChosen?.name }}</span> ?</span>



    </div>

    <ng-template pTemplate="footer">
        <div class="flex justify-end gap-2">
            <p-button label="Annuler" icon="pi pi-times" (onClick)="showConfirmDialog = false"
                styleClass="p-button-text">
            </p-button>
            <p-button label="Confirmer l'achat" (onClick)="confirmPurchase()" icon="pi pi-check">
            </p-button>
        </div>
    </ng-template>
</p-dialog>



<p-dialog [(visible)]="showConfirmResiliationDialog" [modal]="true" [draggable]="false" [resizable]="false"
    [style]="{ width: '400px' }" header="Confirmer la résiliation">

    <div class="text-center">
        <h3 class="text-lg font-semibold mb-4">Confirmer votre demande</h3>
        <span>Êtes-vous sûr de vouloir résilier le plan <span class="font-bold">{{ planToResiliate?.plan_name }}</span> ?</span>

    </div>

    <ng-template pTemplate="footer">
        <div class="flex justify-end gap-2">
            <p-button label="Annuler" icon="pi pi-times" (onClick)="showConfirmResiliationDialog = false"
                styleClass="p-button-text">
            </p-button>
            <p-button label="Confirmer la résiliation" (onClick)="confirmResiliation()" icon="pi pi-check">
            </p-button>
        </div>
    </ng-template>
</p-dialog>

<p-toast [position]="isMobile ? 'bottom-center' : 'top-right'" [styleClass]="isMobile ? 'toast-mobile' : ''"></p-toast>